import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "../lib/LangContext";

export default function LegalPage({ type = "imprint" }) {
  const { t } = useLang();
  const content = type === "imprint" ? t.legal.imprint : t.legal.privacy;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <main className="bg-white text-black min-h-screen pt-32 pb-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-zinc-600 hover:text-black transition-colors gold-link"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>{t.legal.back}</span>
        </Link>
        <h1 className="mt-8 font-display text-4xl sm:text-5xl tracking-tight">{content.title}</h1>
        <p className="mt-4 text-zinc-600">{content.intro}</p>

        <div className="mt-12 space-y-10">
          {content.sections.map((s, i) => (
            <div key={i} className="border-t border-black/10 pt-6">
              <h2 className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] font-semibold">
                {s.h}
              </h2>
              <p className="mt-3 text-base sm:text-lg text-zinc-800 leading-relaxed">{s.b}</p>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
